import qs from "qs";

import { UrlProvider } from "../api/UrlProvider";

/**
 *
 * @param {{
 *   locale: string,
 *   categoryId: string | number,
 *   ticker: string,
 *   market: string,
 *   stockName?: string,
 *   isInsiderAnalysis?: boolean
 * }} options
 * @returns {string | null}
 */
export function getFilteredAnalysesListHref({
  locale,
  categoryId,
  ticker,
  market,
  stockName,
  isInsiderAnalysis = false
}) {
  if (categoryId == null || !ticker || !market || !locale) {
    return null;
  }

  const pathname = UrlProvider.getLocalizedUrl(
    locale,
    isInsiderAnalysis ? "fe.insiderAnalysisList" : "fe.analysisList",
    { locale }
  );

  const search = qs.stringify(
    {
      ticker,
      market,
      category: String(categoryId),
      ...(stockName ? { stockName } : {})
    },
    { addQueryPrefix: true }
  );

  return `${pathname}${search}`;
}
